<template>
	<div id="app">
        <link rel="stylesheet" 
            href="https://use.fontawesome.com/releases/v5.7.2/css/all.css" 
            integrity="sha384-fnmOCqbTlWIlj8LyTjo7mOUStjsKC4pOpQbqyi7RrhN7udi9RwhKkMHpvLbHG9Sr" 
            crossorigin="anonymous">

        <notifications group="main" position="bottom right"/>

		<router-view></router-view>
	</div>
</template>

<script>
export default {
  name: 'app',
	components: {
		
	}
}
</script>

<style lang="scss">

	html, body{
		font-family: 'Roboto', sans-serif;
		font-weight: 300;
	}
    div:focus {
        outline: none;
    }

	body {
		word-break: break-word;
	}

    .navbar {
        background-color: #495966;

        .nav-link {
            color: white!important;
        }
    }

    img {
        max-width: 100%;
    }

	.form-group {
        // margin-top: 30px;

        input {
            margin-bottom: 10px;
        }
    }

    .alert {
        margin-top: 30px;
    }

    .breadcrumb {
        margin-bottom: 0!important;
    }

    .notifications {
        margin-top: 2rem;
		margin-bottom: 0.5rem;
        padding-top: 0.5rem;
        padding-right: 0.5rem;
    }

    .vue-notification {
        font-size: 0.9rem!important;
    }
</style>
